import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { Trans, useTranslation } from "react-i18next";
import CheckIcon from "../../../assets/images/icons/CheckIcon";
import RequestAccessContainer from "../../../components/TailoredGeneration/RequestAccessContainer/RequestAccessContainer";
import BriaButton from "../../../components/common/BriaButton/BriaButton";
import LinkConstants from "../../../constants/LinkConstants";
import { CrmEventTargets, CrmOrgEvents, CrmUserEvents } from "../../../constants/crm";
import { useAppStore } from "../../../hooks/useStores";
import { OrgFeatures } from "../../../models/billing";
import styles from "./ModelsAccess.module.scss";

const ModelsAccess = () => {
	const { authStore } = useAppStore();
	const { t } = useTranslation("translation", { keyPrefix: "models.access" });

	const steps = [
		{
			key: "step1",
			disabled: authStore.isFeatureEnabled(OrgFeatures.FOUNDATION_MODELS),
			render: () =>
				authStore.isFeatureEnabled(OrgFeatures.FOUNDATION_MODELS) ? (
					<Box className={styles.subscribed}>
						<CheckIcon />
						{t("cards.subscribed")}
					</Box>
				) : (
					<Box className={styles.quoteContainer}>
						<RequestAccessContainer
							showCrown={false}
							requestFeature={t("key")}
							crmEvents={[
								{
									eventTarget: CrmEventTargets.ORG,
									eventType: CrmOrgEvents.ORG_REQUESTED_FOUNDATION_MODELS,
								},
								{
									eventTarget: CrmEventTargets.USER,
									eventType: CrmUserEvents.USER_REQUESTED_FOUNDATION_MODELS,
								},
							]}
							buttonType="secondaryMedium"
							buttonMessage={t("cards.step1.button")}
							requestTitle={t("cards.step1.requestTitle")}
							requestMessage={t("cards.step1.requestMessage")}
							submissionMessage={t("cards.step1.submissionMessage")}
						/>
					</Box>
				),
		},
		{
			key: "step2",
			button: {
				label: t("cards.step2.button"),
				onClick: () => window.open(LinkConstants.BRIA_HUGGING_FACE, "_blank"),
			},
		},
		{
			key: "step3",
			button: {
				label: t("cards.step3.button"),
				onClick: () => window.open(LinkConstants.BRIA_AGENT, "_blank"),
			},
		},
	];

	return (
		<Box className={styles.container}>
			<Trans>
				<Typography className={styles.description}>{t("description")}</Typography>
			</Trans>
			<Box className={styles.cards}>
				<Typography className={styles.title}>{t("title")}</Typography>
				<Grid container spacing={3}>
					{steps.map(({ key, render, button, disabled }) => (
						<Grid item xs={12} sm={12} md={6} lg={4} xl={3} key={key}>
							<Box
								className={clsx(styles.card, {
									[styles.disableCard]: disabled,
								})}
							>
								<Typography className={styles.cardStep}>{t(`cards.${key}.title`)}</Typography>
								<Typography className={styles.cardTitle}>{t(`cards.${key}.header`)}</Typography>
								<Typography className={styles.cardDescription}>
									{t(`cards.${key}.description`)}
								</Typography>
								{render ? (
									render()
								) : (
									<BriaButton
										className={styles.cardButton}
										onClick={button?.onClick}
										buttonType="secondaryMedium"
									>
										{button?.label}
									</BriaButton>
								)}
							</Box>
						</Grid>
					))}
				</Grid>
			</Box>
		</Box>
	);
};

export default observer(ModelsAccess);
